export default __webpack_public_path__ + "static/media/call.9c9c8917.svg";